<template>
  <v-btn
    class="mx-2"
    v-show="show"
    id="dialer-minimized"
    color="#607d8b"
    style="z-index:999;"
    @click="onMinimized"
    fab
    dark
    small
    bottom
    right
    fixed
    x-large
  >
    <counter v-if="hasInProgressCall" :status="counterStatus"></counter>
  </v-btn>
</template>

<script>
import Counter from "./Counter.vue";
export default {
  props: {
    show: {
      type: Boolean,
    },
    hasInProgressCall: {
      type: Boolean,
    },
    counterStatus: {
      type: String,
    },
  },

  components: {
    Counter,
  },

  methods: {
    onMinimized() {
      this.$emit("click");
    },
  },
};
</script>

<style></style>
